import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
  } from "../../config/axiosInstance";
  
  // ---------------------fatch-transaction-listing--------------------------
  export const fetchTransactionApi = async (data) => {
    const endPoint =
      `/admin/transaction` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

  // ---------------------fetch-recharge-history--------------------------
  export const fetchRechargeHistoryApi = async (data) => {
    const endPoint =
      `/admin/transaction/recharge-history` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

  // ---------------------fetch-recharge-history-summary (lightweight, for parallel load)--------------------------
  export const fetchRechargeHistorySummaryApi = async (data) => {
    const endPoint =
      `/admin/transaction/recharge-history/summary` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

  // ---------------------fetch-spending-history--------------------------
  export const fetchSpendingHistoryApi = async (data) => {
    const endPoint =
      `/admin/transaction/spending-history` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

  // ---------------------fetch-spending-history-summary (lightweight, for parallel load)--------------------------
  export const fetchSpendingHistorySummaryApi = async (data) => {
    const endPoint =
      `/admin/transaction/spending-history/summary` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

  // ---------------------update-transaction-support-status--------------------------
  export const updateTransactionSupportStatusApi = async (transactionId, data) => {
    const endPoint = `/admin/transaction/update-support-status/${transactionId}`;
    return await axios.put(endPoint, data, setJwtToken());
  };

  // ---------------------fetch-registered-and-recharged-same-day--------------------------
  export const fetchRegisteredAndRechargedSameDayApi = async (data) => {
    const endPoint =
      `/admin/transaction/registered-with-completed-consultations` + "?" + new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };